<template>
    <div :class="classes">
        <transition name="app-transition" mode="out-in">
            <div v-if="isPending"></div>
            <ErrorNoConnection v-else-if="pageState=='serverConnectionError'"/>
            <template v-else-if="isAuthorized||allowGuest">
                <div class="pending-screen" v-if="pageState=='pending' && !isLayoutInside"></div>
                <error403 v-else-if="pageState=='error403'"/>
                <error404 v-else-if="pageState=='error404'"/>
                <error500 v-else-if="pageState=='error500'"/>
            </template>
            <ErrorNoConnection v-else-if="isLoadError"/>
            <Login v-else/>
        </transition>

        <template v-if="isAuthorized||allowGuest">
            <router-view v-show="pageState=='normal' || (pageState=='pending' && isLayoutInside)"
                         :currentObjectDetails="currentObjectDetails"/>
        </template>

        <context-menu v-if="contextMenu!=null" :data="contextMenu"/>
        <transition-group>
            <notification v-for="(x,i) in notifications" :data="x" :key="x.symbol" :style="{'--i':i}"/>
        </transition-group>
    </div>
</template>
<script>
import Layout from "@/common/layout/Layout";
import Login from "@/authorization/Login";
import Error403 from "@/common/layout/Error403";
// import Error404 from "mpts-vue-loader!@/common/layout/Error404.mpts";
import Error404 from "@/common/layout/Error404";
import Error500 from "@/common/layout/Error500";
import ErrorNoConnection from "@/common/layout/ErrorNoConnection";
import ContextMenu from "@/common/utils/ContextMenu";
import Notification from "@/common/layout/Notification";
import objectDefinitions from "@/common/objectDefinitions";
import {Server} from "@/common/server/server";
import {__BUILD_COMMIT_HASH__} from "../../../version";
import QRCode from "qrcode";
import ca from "vue2-datepicker/locale/es/ca";

export default {
    components: {ContextMenu, ErrorNoConnection, Error403, Error404, Error500, Login, Notification},
    data() {
        return {pageState: 'normal', currentObjectDetails: [], locationString: ''}
    },
    methods: {
        setState(state) {
            this.pageState = state;
        },
        setCurrentObjectDetails(x) {
            this.currentObjectDetails = x;
        }
    },
    computed: {
        isAuthorized() {
            return this.$store.state.isAuthorized;
        },
        allowGuest() {
            return this.$route.name == "resetPassword" || this.$route.name == "resetPassword2";
        },
        isPending() {
            return this.$store.state.commonData.status == 1;
        },
        isLoadError() {
            return this.$store.state.commonData.status == 3;
        },
        isLayoutInside() {
            return this.$route.matched[0]?.components?.default === Layout;
        },
        contextMenu() {
            return this.$store.state.contextMenu;
        },
        notifications() {
            return Array.from(this.$store.state.notifications).reverse();
        },
        debugCode() {
            void this.locationString
            return (__BUILD_COMMIT_HASH__ ?? '').substring(0, 6) + '/' + (window.__BACKEND_COMMIT_HASH__ ?? '').substring(0, 2) + '/' + (window.__sessionId ?? '').substring(0, 6) + '/' + Math.round((+new Date() / 1000)).toString(36) + '/' + this.$store.getters.userID
        },
        classes() {
            const date = new Date();
            return {
                primaaprilis: date.getDate() == 1 && date.getMonth() == 3,
            }
        }
    },
    watch: {
        '$route'() {
            this.currentObjectDetails = [];
            const fromLink = objectDefinitions.parseLink(this.$route.fullPath);
            if (fromLink) {
                this.currentObjectDetails.push(fromLink)
            }
        },

        '$route.fullPath': {
            immediate: true,
            deep: true,
            handler() {
                const locationString = window.location.toString();
                if (locationString != this.locationString) {
                    Server.TechnicalLog.SavePageOpen(locationString)
                    this.locationString = locationString;
                }
            }
        },

        debugCode: {
            immediate: true,
            handler() {
                const canvas = document.createElement("canvas");
                QRCode.toCanvas(canvas, this.debugCode, {
                    scale: 2,
                    margin: 2,
                    color: {light: '#ffffff01', dark: '#00000001'}
                })
                console.log('debug code', this.debugCode,);
                document.documentElement.style.setProperty('--debugQrCode', `url(${canvas.toDataURL("image/png")})`)
            }
        }
    }
}
</script>
